import React, { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "./ProjectVideoModal.module.css";
import { IoMdDocument } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import {themeColors} from "../../theme";
import { motion } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";


// import { uploadProjectResources } from "../../../Services/resources";
import { uploadProjectResources } from "../../../Services/projects";
import { showSnackbarAction } from "../../../Redux/actions";
type props = {
  open: boolean;
  close: () => void;
  title: string;
  projectData: any;
  type: string;
  attachmentsList: any[];
  user: any;
  theme:any;
  setLoad:(data:boolean)=>void
  userPreference:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const AttachmentModal: FunctionComponent<props> = ({
  user,
  open,
  close,
  title,
  projectData,
  type,
  attachmentsList,
  theme,
  setLoad,
  userPreference
}) => {
  const dispatcher = useDispatch();


  const upload = async (file: any) => {
    if (userPreference.project_attachments_create_approved === false) {
      dispatcher(
        showSnackbarAction(
          "You are not allowed to add attachment. Contact your admin",
          "error"
        )
      );
    } else {
      let name: any = document.getElementById("file-input");
      let nameList = name.value.split("\\");
      let fileName = nameList[nameList.length - 1];
      close();
      setLoad(true);
      await uploadProjectResources(
        file[0],
        projectData,
        type,
        fileName,
        dispatcher
      );
      setLoad(false);
    }
  };

  const customStyles = {
    content: {
      backgroundColor:theme ? themeColors.dropdownBackgroundColor:themeColors.dropdownBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark
    },
  };
  const containerStyles = { backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}

  return (
    <>
    {/* {load && <Loading />} */}
    {open && <Backdrop>
    <motion.div
                   key="modal"
                   className="card p-4 shadow rounded"
                   style={{position: "absolute",
                   ...containerStyles}}
                   variants={dropIn}
                   initial="hidden"
                   animate="visible"
                   exit="exit"
                 >
      <div className={styles.headingContainer}>
        <h5 
        // className={styles.heading}
        >{title}</h5>
      </div>
      <div
        className={styles.dragBox}
        style={containerStyles}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => {
          e.preventDefault();
          upload(e.dataTransfer.files);
          // setLoad(true);
        }}
      >
        <IoMdDocument size={80} color={"#808080"} />
        <p>Drag And Drop</p>
      </div>

      <div className={styles.uploadContainer}>
        <div className={styles.selectBox}>
          <label htmlFor="file-input" className={styles.uploadButton}>
            {title}
          </label>
          <input
            id="file-input"
            className={styles.select}
            type="file"
            accept=".mp4,.mov,.wmv,.avi,.mkv,.webm,.flv,.avchd,.mts,.gif"
            onChange={(e) => upload(e.target.files)}
          />
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={() => close()}>
            Cancel
          </button>
        </div>
      </div>
                 </motion.div>
    </Backdrop>}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    userPreference:state.userPreference.data
  };
};

export default connect(mapStateToProps)(AttachmentModal);
